export default __webpack_public_path__ + "static/media/annal.b4943dcb.svg";